import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '.';

export const crmApi = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: () => ({}),
    tagTypes: ['SearchSummary', 'CustomerDetail', 'CustomerNotes', 'SearchResults'],
});
